import React from 'react';

import {Link} from "../../../../../core/components/link/link";
import {LinkProps} from "../../../../../core/components/link/link-composer";
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/footer.module.scss";

export const FooterModuleLink = observer(({link, controller, className, onItemClick}) => {
  const {state: {isHomePage}} = controller;
  const {linkModel, forceFollow, label, isDynamicLink, isExternal} = link;

  const shouldRenderAnchorTag: Boolean = linkModel?.url || isDynamicLink;
  const isNoFollowLink: Boolean = !isHomePage && !forceFollow;
  const shouldOpenNewTab: Boolean = !isDynamicLink || isExternal;

  const linkProps: LinkProps = {
    model: linkModel,
    noFollow: isNoFollowLink,
    className: classNames(styles.link, className),
    onClick: () => onItemClick && onItemClick(link),
  }

  const anchorProps = {
    className: classNames(styles.link, className),
    href: linkModel?.url || link.urlLink,
    rel: isNoFollowLink ? 'nofollow' : '',
    target: shouldOpenNewTab ? '_blank' : '',
    onClick: () => onItemClick && onItemClick(link),
  }

  return shouldRenderAnchorTag ? <a {...anchorProps}>{label}</a> : <Link {...linkProps}>{label}</Link>
})
